(function ($) {
  $(document).ready(function () {
    $(".product-info-drawer .open-drawer").click(function () {
      $(".product-info-drawer .drawer").addClass("active");
      $(".product-info-drawer .drawer").css({
        visibility: "visible",
      });
      $(".product__info-container").css({
        height: "100%",
      });
    });
    $(".product-info-drawer .drawer__close").click(function () {
      if ($(".product-info-drawer .drawer").hasClass("active")) {
        $(".product-info-drawer .drawer").removeClass("active");
      }
      $(".product-info-drawer .drawer").css({
        visibility: "hidden",
      });
      $(".product__info-container").css({
        height: "auto",
      });
    });


    $(".product-care-drawer .open-drawer").click(function () {
      $(".product-care-drawer .drawer").addClass("active");
      $(".product-care-drawer .drawer").css({
        visibility: "visible",
      });
      $(".product__care-container").css({
        height: "100%",
      });
    });
    $(".product-care-drawer .drawer__close").click(function () {
      if ($(".product-care-drawer .drawer").hasClass("active")) {
        $(".product-care-drawer .drawer").removeClass("active");
      }
      $(".product-care-drawer .drawer").css({
        visibility: "hidden",
      });
      $(".product__care-container").css({
        height: "auto",
      });
    });

    $(".how-to-wear-drawer .open-drawer").click(function () {
      $(".how-to-wear-drawer .drawer").addClass("active");
      $(".how-to-wear-drawer .drawer").css({
        visibility: "visible",
      });
      $(".product__info-container").css({
        height: "100%",
      });
    });
    $(".how-to-wear-drawer .drawer__close").click(function () {
      if ($(".how-to-wear-drawer .drawer").hasClass("active")) {
        $(".how-to-wear-drawer .drawer").removeClass("active");
      }
      $(".how-to-wear-drawer .drawer").css({
        visibility: "hidden",
      });
      $(".product__info-container").css({
        height: "auto",
      });
    });


    
    if ($('.breadcrumbs__item.parent-col').length) {
      var href = $('.breadcrumbs__item.parent-col').find('a.breadcrumbs__link').attr('href');
      $('.product__info-wrapper .button-wrapper a').attr("href", href);
    } else {
      var href = $('.breadcrumbs__item.home').find('a.breadcrumbs__link').attr('href');
      $('.product__info-wrapper .button-wrapper a').attr("href", href);
    }


    
    // video Youtube autoplay if hover

      $(".related-products .grid__item .card-wrapper").on({
        mouseenter: function() {
          var $iframe = $(this).find('iframe');
          if ($iframe.length > 0) {
            var videoSrc = $iframe.attr('src');
            if (videoSrc) {
              if (videoSrc.indexOf('&autoplay=1') == -1) {
                $iframe.attr('src', videoSrc + '&autoplay=1&mute=1');
              }
            }
          }
        },
        mouseleave: function() {
          var $iframe = $(this).find('iframe');
          if ($iframe.length > 0) {
            var videoSrc = $iframe.attr('src');
            if (videoSrc) {
              if (videoSrc.indexOf('&autoplay=1') != -1) {
                $iframe.attr('src', videoSrc.replace('&autoplay=1&mute=1', ''));
              }
            }
          }
        }
      });
  });
})(jQuery);

































